import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  useHistory,
  useLocation,
  useParams,
  withRouter,
} from 'react-router-dom'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import { typesOfDocumentsActions } from '../../actions/typesOfDocumentsActions'
import { routes } from '../../constantes/routes'
import ProductPresentationCard from '../presentation/edit-presentation/ProductPresentationCard'
import { NoInfo } from '../common/NoInfo'
import { productsContactPresentationActions } from '../../actions/accessToPresentationByContact/infoProfileContactHospitalPresentationActions'
import FinalProductContainer from '../final-product/FinalProductConainer'
import '../../assests/styles/accessPresentation/headerPresentation.scss'
import { articlesApi } from '../../api/articlesApi'
import BackBtn from '../buttons/BackBtn'
import DownloadBtn from '../buttons/DownloadBtn'
import HeaderPresentation from './header/HeaderPresentation'
import { presentationProductsApi } from '../../api/presentationsApi'
import { swalAlertError } from '../../utils/swalAlert'
import './contactHospitalPresentation.scss'
import { infoProfileContactHospitalPresentationTypes } from '../../constantes/actionTypes'
import { set } from 'lodash'
import { Footer } from '../common/Footer'

const ViewContactHospitalPresentationContainer = () => {
  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()

  const productsContactPresentation = useSelector(
    (state) => state.productsContactPresentation,
  )
  const infoProfileContactHospitalPresentation = useSelector(
    (state) => state.infoProfileContactHospitalPresentation,
  )

  const [itemSelected, setItemSelected] = useState('')
  // Estado para la visualizacion del producto final
  const [isfinalProductView, setFinalProductView] = useState(false)

  const [presentationReady, setPresentationReady] = useState(false)

  const dispatch = useDispatch()
  const getAllTypesDocuments = () =>
    dispatch(typesOfDocumentsActions.getAllTypesOfDocuments())

  useEffect(() => {
    getProductsContactPresentation()
    getAllTypesDocuments()
  }, [])

  useEffect(() => {}, [isfinalProductView])

  const getProductsContactPresentation = async () => {
    try {
      const products = await dispatch(
        productsContactPresentationActions.getProductsContactPresentation(id),
      )
      setPresentationReady(true)
    } catch (error) {
      setPresentationReady(false)
      // swalAlertError("No hay productos para visualizar en esta presentación")

      // history.push(routes.LANDING)
    }
  }

  // --- funciones auxiliares para visualizar el PRODUCTO FINAL
  const goToDetailProduct = async (idArticle) => {
    const resp = await articlesApi.getInfoArticle(idArticle)
    if (resp.data) {
      setItemSelected(resp.data)
      history.push(location.pathname + '/info')
      setFinalProductView(true)
    }
  }

  const handleDownloadDocument = async (event) => {
    event.preventDefault()

    const getDocsInPresentation =
      await presentationProductsApi.getPresentationDocs(id)

    if (!getDocsInPresentation.data) {
      swalAlertError('No hay documetos para descargar')
      return
    }
    debugger
    const zip = new JSZip()
    const folder = zip.folder(
      infoProfileContactHospitalPresentation.nombrePresentation,
    ) // folder name where all files will be placed in
    await Promise.all(
      getDocsInPresentation.data.map(
        async (element) =>
          await articlesApi
            .getFile({ route: element.ruta })
            .then(async (res) => {
              const stremArray = res.data
              return new Blob([stremArray], { type: 'application/pdf' })
            })
            .then(async (res) => {
              return folder.file(element.nombreDocumento, res)
            }),
      ),
    )
    await zip
      .generateAsync({ type: 'blob' })
      .then(async (blob) =>
        FileSaver.saveAs(
          blob,
          infoProfileContactHospitalPresentation.nombrePresentation,
        ),
      )
  }

  const toPresentation = (id) => {
    history.push(routes.VIEW_CONTACT_PRESENTATION + id)
    setFinalProductView(false)
  }

  if (!presentationReady)
    return (
      <div className='acces-presentation__container'>
        <HeaderPresentation />
          <div className='products__title__container mb-10'>
            <h3>Esta Presentación ya no es válida.</h3>
          </div>
      </div>
    )

  return (
    <div>
      
      <div className='acces-presentation__container'>
        <HeaderPresentation />
        <div className="acces-presentation__download-btn-container">
          <button
            className=' btn-shape btn-download'
            onClick={(e) => handleDownloadDocument(e)}
          >
            <DownloadBtn /> Descargar documentos
          </button>
        </div>
        <div className='acces-presentation__products-container'>
          {!isfinalProductView ? (
            <div>
              <div className='products__title__container mb-10'>
                <h3>Productos</h3>
              </div>
              <div className='frameless'>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  {productsContactPresentation
                    ? productsContactPresentation.map((product, i) => (
                        <div className='products__table mb-50' key={i}>
                          <div className='card__horizontal mb-30'>
                            <h4 className='products__sub'>
                              {product.nombreArticulo}
                            </h4>
                          </div>
                          <ProductPresentationCard
                            product={product}
                            goToViewDetailProduct={goToDetailProduct}
                            handleDownloadDocument={handleDownloadDocument}
                          />
                        </div>
                      ))
                    : NoInfo('No hay productos que mostrar')}
                </div>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: '50px' }}>
              <a className='header__back' onClick={() => toPresentation(id)}>
                {' '}
                <BackBtn />{' '}
              </a>
              
              <FinalProductContainer
                item={itemSelected}
                idPresentation={
                  infoProfileContactHospitalPresentation.id_Presentacion
                }
                onlyViewDocsProduct={true}
              />
            </div>
          )}
        </div>
        
      </div>

      <Footer />

    </div>
  )
}

export default withRouter(ViewContactHospitalPresentationContainer)
